export default __webpack_public_path__ + "static/media/p3.8052743a.jpg";